import { get } from "lodash";
/**
 * Automatically imports all the configurautions
 */
const requireModule = require.context("@", true, /\.settings\.js$/);
const modules = {};

requireModule.keys().forEach((filename) => {
    // create the module name from fileName
    const moduleName = filename
        .replace(/(\.\/|\.settings\.js)/g, "")
        .split("/")
        .pop();

    modules[moduleName] =
        requireModule(filename).default || requireModule(filename);
});

export const config = (path) => {
    return get(modules, path);
};
